import { render } from "./np-textarea.vue?vue&type=template&id=25b77c40"
import script from "./np-textarea.vue?vue&type=script&lang=js"
export * from "./np-textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__